import React, { Component } from "react";
import PropTypes from "prop-types";

class RKPayBadge extends Component {
	shouldComponentUpdate = ({ isRKPay, iconSize, textSize, className }) => {
		const lastProps = this.props;

		return (
			isRKPay !== lastProps.isRKPay ||
			iconSize !== lastProps.iconSize ||
			textSize !== lastProps.textSize ||
			className !== lastProps.className
		);
	};

	render() {
		const { isRKPay, iconSize, textSize, className } = this.props;

		return (
			<If condition={isRKPay}>
				<p className={`color-blue-picton margin-bottom-0 ${className}`}>
					<i
						className="rkf rkf-wallet"
						style={{ fontSize: iconSize }}
					/>
					<span
						className="display-block"
						style={{ fontSize: textSize }}
					>
						RKPay
					</span>
				</p>
			</If>
		);
	}
}

RKPayBadge.propTypes = {
	isRKPay: PropTypes.bool,
	iconSize: PropTypes.number,
	textSize: PropTypes.number,
	className: PropTypes.string,
};

RKPayBadge.defaultProps = {
	isRKPay: false,
	iconSize: 26,
	textSize: 12,
	className: "",
};

export default RKPayBadge;
